export const isNotNullOrUndefined = (val) => {
  const result = val ?? 'null or undefined';
  return result === val;
}
